import type { DashboardLayoutConfig } from './dashboard-layout'
import { DEFAULT_LAYOUT_CONFIG } from './dashboard-layout'

const STORAGE_KEY = 'oxigen_dashboard_layout'

export function saveDashboardLayout(config: DashboardLayoutConfig): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config))
  } catch (error) {
    console.error('Failed to save dashboard layout:', error)
  }
}

export function loadDashboardLayout(): DashboardLayoutConfig {
  if (typeof window === 'undefined') return DEFAULT_LAYOUT_CONFIG

  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const parsed = JSON.parse(stored)

      // List of deprecated widget IDs to remove
      const deprecatedWidgets = ['watched-issues']

      // Filter out deprecated widgets from stored configuration
      const filteredWidgets = parsed.widgets.filter(
        (w: any) => !deprecatedWidgets.includes(w.id)
      )

      // Merge with defaults to ensure all new widgets are included
      const storedWidgetIds = new Set(filteredWidgets.map((w: any) => w.id))
      const newWidgets = DEFAULT_LAYOUT_CONFIG.widgets.filter(
        w => !storedWidgetIds.has(w.id)
      )

      return {
        ...parsed,
        widgets: [...filteredWidgets, ...newWidgets]
      }
    }
  } catch (error) {
    console.error('Failed to load dashboard layout:', error)
  }

  return DEFAULT_LAYOUT_CONFIG
}

export function resetDashboardLayout(): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    console.error('Failed to reset dashboard layout:', error)
  }
}
